import { render, staticRenderFns } from "./estudante-historico-academico.vue?vue&type=template&id=270b01ba&"
import script from "./estudante-historico-academico.vue?vue&type=script&lang=js&"
export * from "./estudante-historico-academico.vue?vue&type=script&lang=js&"
import style0 from "./estudante-historico-academico.vue?vue&type=style&index=0&id=270b01ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports